'use client'

import { useEffect } from 'react'

// Counts a view of an AI post on AIBlogWrite's dashboard: the same request
// the package's 1px tracking image makes, sent from the reader's browser
// once the page has loaded. Requested from script rather than as an <img> in
// the HTML, so crawlers no longer report an external, alt-less image (or the
// tracker's own script and stylesheet) as part of the article. Automated
// browsers are skipped, as for CTA clicks. Renders nothing.
export default function AiViewCount({ url }) {
  useEffect(() => {
    if (!url || navigator.webdriver) return
    const beacon = new Image()
    beacon.src = url
  }, [url])
  return null
}
